import { useGetBlogsQuery } from '@apis/mediacore/blog'
import { formatDate } from '@helpers/helper.novelty'
import { ElementHTML } from '@helpers/helper.rendering'
import React, { useEffect, useState } from 'react'
import { Container, Row } from 'react-bootstrap'
import { Novelty, RealEstateDataPageComponentData } from 'types'
import Slider_6 from '@boilerplates/sliders/1'

const Summary_Novelties_9 = (props: RealEstateDataPageComponentData) => {
  const { title, titleElement, titleColor, global_data, image } = props
  const { id: siteId, divisionPath } = global_data

  const { data: allBlogData, isLoading, isError } = useGetBlogsQuery({ site: siteId })

  const getFeaturedAndRefillByDate = () => {
    if (allBlogData) {
      const featured = allBlogData.news.filter((novelty) => novelty.featured)
      const notfeatured = allBlogData.news.filter((novelty) => !novelty.featured)
      const total = [...featured, ...notfeatured]
      return total.slice(0, 3)
    }
  }

  const [isComponentMounted, setIsComponentMounted] = useState(false)

  useEffect(() => {
    setIsComponentMounted(true)
  }, [])

  const noveltyPath = (novelty: Novelty) =>
    novelty?.id ? `${divisionPath ?? ''}/novedad/${novelty.id}/${novelty.slug}` : '/'

  type SlideItem = {
    photo?: string
    top_string?: string | number
    title?: string
    paragraph?: string
    link?: string
    cta?: string
    btn_image?: string
  }

  const slide_items: SlideItem[] =
    getFeaturedAndRefillByDate()?.map((novelty) => ({
      title: novelty?.title ?? '',
      top_string: formatDate(novelty?.date_published, 'long'),
      link: noveltyPath(novelty),
      cta: 'VER NOTA COMPLETA',
      btn_image: image,
      paragraph: novelty?.headline ?? '',
      photo: novelty?.image ?? '',
    })) ?? []

  return (
    isComponentMounted &&
    !isError &&
    !isLoading &&
    getFeaturedAndRefillByDate()?.length !== 0 && (
      <section
        id="summary-novelties"
        className="p-y-config"
      >
        <Container fluid>
          <Row className="d-flex text-start">
            <ElementHTML
              children={title ?? 'Novedades más recientes'}
              elementType={titleElement ?? 'h2'}
              style={titleColor ? { color: titleColor } : {}}
            />
          </Row>
        </Container>
        <Slider_6 slide_items={slide_items} />
      </section>
    )
  )
}

export default Summary_Novelties_9
